import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { VideoDetailsDialogComponent } from './video-details-dialog.component';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		FormsModule,
		ReactiveFormsModule,
		A11yModule
	],
	declarations: [
		VideoDetailsDialogComponent
	],
	exports: [
		VideoDetailsDialogComponent
	]
})
export class VideoDetailsDialogModule {}
